<template>
	<div id="paymentmodal">
    <button
      type="button"
      class="btn btn-primary pull-right"
      @click="showModal"
      data-toggle="tooltip"
      data-placement="top"
      :title="(paid == 'true') ? '' : paying_modal_message"
    >
    {{( paid == "true") ? agreement : text }}
    </button>

    <div id="modaltop" class="modal fade show" tabindex="-1" role="dialog" style="display:block;" v-show="isModalVisible">
      <div id="modalmid" class="modal-dialog">
        <div class="modal-content">
          <spinner :loading="isLoading" />
          <div class="modal-body" id="paymentcontent" style="color:black;text-align:center;">
          </div>

          <div class="modal-footer" style="text-align: center;border-top: none;">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from './components/modal.vue'
import Spinner from './components/spinner.vue'
export default {
	components: {
    Modal,Spinner
	},
  props: ["name", "next", "text", "agreement", "sign", "accept", "page", "paid", "paying_modal_message"],
  data() {
    return {
      isLoading: false,
      isModalVisible: false,
    }
  },
  methods: {
    submit(){
      console.log(this);
    },
    closeYes(){
    },
    notLoading(){
      this.isLoading = false
    },
    showModal() {
      if (this.paid == "true"){
        window.location = this.accept;
        return
      }
      let pm = this;
      this.isLoading = true;
      const params = new URLSearchParams({
        page: this.page
      });

      fetch(`${this.next}payment/get_payment_content?${params.toString()}`, {
        method: 'GET',
        credentials: 'include', // send cookies like jQuery
        headers: {
          'Accept': 'text/html'
        }
      })
      .then(response => {
        if (!response.ok) throw response;
        return response.json();
      })
      .then(result => {
        pm.notLoading();
        document.getElementById('paymentcontent').innerHTML = result.html;

        document.dispatchEvent(
          new CustomEvent('paymentContentLoaded', {
            detail: { message: 'Payment form is loaded' },
            bubbles: true,
            cancelable: true
          })
        );
      })
      .catch(error => {
        // handle error
        console.error('Failed to load payment content:', error);
      });

      //window.jQuery(this.$refs.modal.$el).modal('show')
      //$('#modaltop').modal('show');
      this.isModalVisible = true;
    },
    closeModal() {
     //window.jQuery(this.$refs.modal.$el).modal('hide')
     //$('#modaltop').modal('hide');
     this.isModalVisible = false;
    },
  }
}
</script>

<style lang="scss">

*, *::before, *::after {
	box-sizing: border-box;
}

#paymentmodal {
	margin: 0 auto;
	line-height: 1.4;
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: blue;
}

h1 {
	text-align: center;
}
</style>
